import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

export class CondAutonMaBar extends AbstractChart {
    protected allChartOptions(): Options {
        return super.mergeOptions(
            super.allChartOptions(), {
                chart: {
                    type: 'bar',
                },
                yAxis: {
                    tickInterval: 50,
                },
                xAxis: {
                    labels: {
                        align: 'left',
                        reserveSpace: true,
                    }
                },
                legend: {
                    enabled: false,
                },
                plotOptions: {
                    bar: {
                        maxPointWidth: 30,
                        pointWidth: 30,
                        dataLabels: {
                            enabled: true,
                            inside: true,
                            style: {
                                fontSize: '13px',
                                color: 'white',
                                textOutline: 'none'
                            },
                            formatter: function () {
                                return `${this.y.toFixed(1)}%`;
                            }
                        },
                    },
                    series: {
                        stacking: 'normal'
                    }
                }
            }
        );
    }
}

export default function () {
    registerPlugin(CondAutonMaBar)
}
